import { ChatService } from "../../chat.service";
import { WorkspacesService } from "../../main/accountant/workspaces.service";
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  ElementRef,
  Input,
  ViewChildren,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  IterableDiffers,
  DoCheck,
  Renderer2,
  QueryList,
  OnDestroy,
  inject,
  DestroyRef,
  HostListener,
} from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { NgIf, NgClass, NgFor, NgStyle } from "@angular/common";
import { DragDropDirective } from "../../main/common/drag-drop.directive";

import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ConversationsService } from "../conversations.service";
import { DashboardService } from "../../dashboard.service";
import { ClientService } from "../../main/client/client.service";
import { Subject, Subscription, publish, takeUntil } from "rxjs";

// Modals
import { CommentsModalComponent } from "../modals/comments-modal.component";

import { Conversation } from "../panels/conversation.model";
import { GeneralUtil } from "../../../utils/general";
import { Firestore, addDoc, collection } from "@angular/fire/firestore";
import { MessageBubbleService } from "../message-bubble/message-bubble.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { DashboardStore } from "../../dashboard.store";
import { AssistantService } from "../../ai-assistant/assistant.service";
import { AutosizeModule } from "ngx-autosize";
import { MessageBubbleComponent } from "../message-bubble/message-bubble.component";
import { FormsModule } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var jQuery: any;

@Component({
  selector: "chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
  host: {
    "(window:paste)": "fileChange($event, 'PASTE')",
  },
  imports: [
    FormsModule,
    NgStyle,
    MessageBubbleComponent,
    NgClass,
    AutosizeModule,
    NgIf,
    NgFor,
    DragDropDirective,
  ],
})
export class ChatComponent implements OnInit, AfterViewInit, OnDestroy {
  bsModalRef: BsModalRef;

  @ViewChild("inputMessage", { static: true }) inputMessage: ElementRef;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  @ViewChild("chatFile", { static: true }) chatFile: ElementRef;
  @ViewChild("scrollMe", { static: true }) scrollMe: ElementRef;

  @ViewChildren("bubble", { read: ElementRef }) bubbles: QueryList<any>;

  message: any = "";
  messages: any = [];

  filteredMessages: any = [];

  currentMessageFilter: any = "all";

  user: any = {};
  generalUtil = new GeneralUtil();
  is_tab_hidden = false;
  data: any = this.localStorage.get("data");
  conversationArchived: boolean;
  explorer: any;
  fileForm: FormData = new FormData();
  has_file = false;
  file_name = "";
  file_ext = "";
  upload_loading: boolean;
  chat: any;
  chatName: any;
  scrollHeight: any = 0;
  params: any = {};
  limit = 1000;
  start = null;
  count = 100;
  history = [];
  found_messages = [];
  pinnedMessages = [];
  searchText = "";
  searchMode = false;
  pinnedMessagesMode = false;
  searchResultsMode = false;
  jumpedToMessage = false;
  isFocused = false;
  private differ: IterableDiffers;

  all_messages = [];

  has_more_messages = false;
  last_loaded_timestamp = null;

  dispatchSub: Subscription;

  conversation: Conversation = new Conversation();

  company_uuid: string;

  company_id: number;

  company_name: string;

  replyingTo: any = null;

  shouldJumpToMessage = null;

  readonly destroyRef = inject(DestroyRef);

  has_modification() {
    console.log("checking for modification", this.conversation.messages);
    return (
      this.conversation.messages.filter((m) => {
        return m.type == "modified";
      }).length > 0
    );
  }

  // @Input()
  // set conversation(value: Conversation) {
  //   if (value !== undefined) {
  //     if (value.uuid !== undefined && value.uuid != this.conversation.uuid) {

  //     }
  //   }
  // }

  isDragging = false;
  files: File[] = [];
  showDropzone = false;

  private routerSubscription: Subscription;

  private dragCounter = 0;

  @ViewChild('chatPanel', { static: true }) chatPanel: ElementRef;

  constructor(
    private localStorage: LocalStorageService,
    private conversationsService: ConversationsService,
    private modalService: BsModalService,
    private dashboardService: DashboardService,
    private clientService: ClientService,
    private workspacesService: WorkspacesService,
    private renderer: Renderer2,
    private router: Router,
    private ref: ChangeDetectorRef,
    private firestore: Firestore,
    private chatService: ChatService,
    private differs: IterableDiffers,
    private messageBubbleService: MessageBubbleService,
    private dashboardStore: DashboardStore,
    private aiAssistantService: AssistantService,
  ) {
    this.differ = differs;
    // ref.detach(); // deactivate change detection
    // setInterval(() => {
    //   this.ref.detectChanges(); // manually trigger change detection
    // }, 250);
  }

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");

    this.inputMessage.nativeElement.focus();
    // this.scrollToBottom();
    document.addEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
      false,
    );

    // Reset dropzone on route change
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showDropzone = false;
        this.files = [];
        this.has_file = false;
        if (this.chatFile && this.chatFile.nativeElement) {
          this.chatFile.nativeElement.value = '';
        }
      }
    });

    this.chatService.showBotMessages
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub: any) => {
        if (sub.conversation_id == this.conversation.uuid) {
          this.conversation.options["show_bot_messages"] = sub.show;
          this.ref.detectChanges();
        }
      });

    this.workspacesService.showSearch
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub) => {
        this.searchMode = !this.searchMode;
        // this.renderer.invokeElementMethod(this.searchInput.nativeElement, 'focus', []);
        this.searchInput.nativeElement.focus();
      });

    this.workspacesService.$conversation
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((conversation) => {
        this.message = "";
        this.conversation = conversation;

        let chat = this.chatService.getChatByConversationUUID(
          this.conversation.uuid,
        );

        if (chat) this.conversation = chat;

        if (this.shouldJumpToMessage != null) {
          console.log("jumping to message", this.shouldJumpToMessage);
          this.jumpToMessage(this.shouldJumpToMessage);
          this.shouldJumpToMessage = null;
        }

        this.workspacesService.changeMessagesFilter.next("all");

        this.readConversation();

        this.workspacesService.refreshSystemBotStatus.subscribe((sub) => {
          this.conversation["options"] = sub;
        });

        this.conversationsService.updateUnreadConversations.next({});
      });

    this.chatService.chatLoaded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((uuid) => {
        if (this.conversation.uuid == uuid) {
          setTimeout(() => {
            this.scrollToBottom();
          }, 10);
        }
      });

    this.workspacesService.showPinnedMessages
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub) => {
        this.pinnedMessagesMode = !this.pinnedMessagesMode;
        this.workspacesService.refreshPinnedMessages.next(null);
      });

    this.workspacesService.changeMessagesFilter
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filter) => {
        this.currentMessageFilter = filter;

        if (filter == "all") {
          this.filteredMessages = this.conversation.messages;
        } else if (filter == "pinned") {
          this.filteredMessages = this.conversation.messages.filter((m) => {
            return m.pinned == true || m.pinned == "pinned";
          });
        } else if (filter == "unpinned") {
          this.filteredMessages = this.conversation.messages.filter((m) => {
            return (
              m.pinned == false || m.pinned == "unpinned" || m.pinned == null
            );
          });
        } else if (filter == "completed") {
          this.filteredMessages = this.conversation.messages.filter((m) => {
            return m.pinned == "completed";
          });
        }

        this.dashboardStore.selectMessage$
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((message) => {
            if (message) {
              this.shouldJumpToMessage = message.content;

              setTimeout(() => {
                let rendered_bubbles = this.bubbles.toArray();

                for (let b = 0; b < rendered_bubbles.length; b++) {
                  if (rendered_bubbles[b].nativeElement != null) {
                    if (
                      rendered_bubbles[b].nativeElement.id ==
                      `bubble-${this.shouldJumpToMessage.id}`
                    ) {
                      setTimeout(() => {
                        rendered_bubbles[b].nativeElement.scrollIntoView();
                      }, 200);
                    }
                  }
                }
              }, 1000);
            }
          });

        this.ref.detectChanges();
      });

    this.chatService.setReplyingTo
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub) => {
        this.replyingTo = sub;
        this.inputMessage.nativeElement.focus();
      });
    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        this.company_uuid = company.uuid;
        this.company_id = company.id;
        this.company_name = company.name;
      });
  }

  ngAfterViewInit(): void {
    this.inputMessage.nativeElement.focus();

    // Add drag/drop listeners to the chat panel
    if (this.chatPanel && this.chatPanel.nativeElement) {
      this.chatPanel.nativeElement.addEventListener('dragenter', this.onDragEnter.bind(this));
      this.chatPanel.nativeElement.addEventListener('dragover', this.onDragOver.bind(this));
      this.chatPanel.nativeElement.addEventListener('dragleave', this.onDragLeave.bind(this));
      this.chatPanel.nativeElement.addEventListener('drop', this.onDrop.bind(this));
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.chatPanel && this.chatPanel.nativeElement) {
      this.chatPanel.nativeElement.removeEventListener('dragenter', this.onDragEnter.bind(this));
      this.chatPanel.nativeElement.removeEventListener('dragover', this.onDragOver.bind(this));
      this.chatPanel.nativeElement.removeEventListener('dragleave', this.onDragLeave.bind(this));
      this.chatPanel.nativeElement.removeEventListener('drop', this.onDrop.bind(this));
    }
  }

  public openModal(modal, tracked_item = null) {
    if (modal === "comments") {
      modal = CommentsModalComponent;
      this.bsModalRef = this.modalService.show(modal);
      this.bsModalRef.content.ngOnChanges({ tracked_item: tracked_item });
      return;
    }
  }

  get_all_history(start = null) {
    this.found_messages = [];

    // Get the first 100 messages

    for (let x = 0; x < this.conversation.messages.length; x++) {
      if (
        (this.conversation.messages[x].message !== null &&
        this.conversation.messages[x].message !== undefined
          ? this.conversation.messages[x].message
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) !== -1
          : false) ||
        (this.conversation.messages[x].tracked_item !== null &&
        this.conversation.messages[x].tracked_item !== undefined
          ? this.conversation.messages[x].tracked_item.message
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) !== -1
          : false) ||
        (this.conversation.messages[x].tracked_item !== null &&
        this.conversation.messages[x].tracked_item !== undefined
          ? this.conversation.messages[x].tracked_item.answer_text !== null
            ? this.conversation.messages[x].tracked_item.answer_text
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) !== -1
            : false
          : false)
      ) {
        let searchItem = {
          item: this.conversation.messages[x],
          previous: null,
          next: null,
        };

        if (
          searchItem.item.message !== undefined ||
          searchItem.item.tracked_item.answer_text !== null
        ) {
          this.found_messages.push(searchItem);
          let split_message = [];
          let split_answer = [];

          if (
            this.conversation.messages[x].message !== null &&
            this.conversation.messages[x].message !== undefined
          ) {
            split_message = searchItem.item.message.split(" ");
          }

          if (
            this.conversation.messages[x].tracked_item !== null &&
            this.conversation.messages[x].tracked_item !== undefined
          ) {
            split_message = searchItem.item.tracked_item.message.split(" ");
            console.log("its a client task");

            if (
              this.conversation.messages[x].tracked_item.answer_text !==
                undefined &&
              this.conversation.messages[x].tracked_item.answer_text !== null
            ) {
              console.log("answer text");
              split_answer =
                searchItem.item.tracked_item.answer_text.split(" ");
            }
          }

          for (let y = 0; y < split_message.length; y++) {
            if (
              split_message[y]
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) !== -1
            ) {
              split_message[y] =
                `<span class="highlighted-result"><span class="search-keyword">${split_message[y]}</span></span>`;

              if (
                this.conversation.messages[x].message !== null &&
                this.conversation.messages[x].message !== undefined
              ) {
                searchItem.item.message = split_message.join(" ");
              }

              if (
                this.conversation.messages[x].tracked_item !== null &&
                this.conversation.messages[x].tracked_item !== undefined
              ) {
                searchItem.item.tracked_item.message = split_message.join(" ");
              }
            }
          }

          for (let y = 0; y < split_answer.length; y++) {
            if (
              split_answer[y]
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) !== -1
            ) {
              split_answer[y] =
                `<span class="highlighted-result"><span class="search-keyword">${split_answer[y]}</span></span>`;

              if (
                this.conversation.messages[x].tracked_item !== null &&
                this.conversation.messages[x].tracked_item !== undefined
              ) {
                searchItem.item.tracked_item.answer_text =
                  split_answer.join(" ");
              }
            }
          }

          if (this.conversation.messages[x + 1] !== undefined) {
            searchItem.next = this.conversation.messages[x + 1];
          }

          if (this.conversation.messages[x - 1] !== undefined) {
            searchItem.previous = this.conversation.messages[x - 1];
          }

          // this.found_messages.push(searchItem);
        }
      }

      this.history.push(this.conversation.messages[x]);
      this.searchResultsMode = true;
    }
  }

  toggleDropzone() {
    this.showDropzone = !this.showDropzone;
    if (this.showDropzone) {
      // If we're showing the dropzone, we don't want to trigger the file input
      event?.preventDefault();
    }
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    
    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files);
      this.handleFiles(droppedFiles);
    }
  }

  fileChange(event: Event | ClipboardEvent, source: string = 'INPUT') {
    if (source === 'PASTE') {
      const clipboardEvent = event as ClipboardEvent;
      if (clipboardEvent.clipboardData?.files.length) {
        const pastedFiles = Array.from(clipboardEvent.clipboardData.files);
        this.handleFiles(pastedFiles);
        this.showDropzone = true;
      }
    } else {
      const input = event.target as HTMLInputElement;
      if (input.files) {
        const selectedFiles = Array.from(input.files);
        this.handleFiles(selectedFiles);
      }
    }
  }

  private handleFiles(newFiles: FileList | File[]) {
    // Convert FileList to Array if needed
    const filesArray = Array.isArray(newFiles) ? newFiles : Array.from(newFiles);
    
    // Filter out files that are already in the list
    const uniqueFiles = filesArray.filter(newFile => 
      !this.files.some(existingFile => 
        existingFile.name === newFile.name && 
        existingFile.size === newFile.size
      )
    );
    
    this.files = [...this.files, ...uniqueFiles];
    this.has_file = this.files.length > 0;

    // Handle image previews
    uniqueFiles.forEach(file => {
      const ext = this.getFileExtension(file.name);
      if (['jpg', 'jpeg', 'gif', 'png'].includes(ext)) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Add the preview URL to the file object
          file['preview'] = reader.result;
        };
      }
    });
  }

  removeFile(file: File) {
    this.files = this.files.filter(f => f !== file);
    this.has_file = this.files.length > 0;
  }

  getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }

  async send_message() {
    if (this.message.trim() === '' && this.files.length === 0) return;

    // Upload files first if any
    if (this.files.length > 0) {
      this.upload_loading = true;
      try {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i];
          this.fileForm = new FormData();
          this.fileForm.append("file", file, file.name);
          
          // Only include message with the first file
          if (i === 0) {
            this.fileForm.append("msg", this.message);
          } else {
            this.fileForm.append("msg", "");
          }
          
          const file_data = await this.conversationsService.add_message_file(
            this.fileForm,
            this.conversation.id,
          );

          var publishConfig = {
            channel: `conversation-${this.conversation.uuid}`,
            message: {
              message: i === 0 ? this.message : "",
              tracked_item: null,
              system_message: null,
              file: file_data.file,
              date: this.chatService.getFirestoreServerDate(),
              reminder: false,
              sent_by: {
                full_name: this.localStorage.get("user")["full_name"],
                id: this.localStorage.get("user")["id"],
                email: this.localStorage.get("user")["email"],
              },
              replyingTo: this.replyingTo,
            },
            meta: null,
          };

          await addDoc(
            collection(
              this.firestore,
              `chats/${this.conversation.uuid}/messages`,
            ),
            publishConfig.message,
          );
        }
      } finally {
        this.upload_loading = false;
        this.files = [];
        this.has_file = false;
        this.message = "";
        this.showDropzone = false;
        this.inputMessage.nativeElement.focus();
      }
    } else if (this.message.trim()) {
      // Send message if there is one
      let messageCopy = this.message;
      this.message = "";
      this.inputMessage.nativeElement.focus();
      
      if (!this.conversationArchived) {
        var publishConfig = {
          channel: `conversation-${this.conversation.uuid}`,
          message: {
            message: messageCopy,
            tracked_item: null,
            system_message: null,
            file: null,
            date: this.chatService.getFirestoreServerDate(),
            reminder: false,
            sent_by: {
              full_name: this.localStorage.get("user")["full_name"],
              id: this.localStorage.get("user")["id"],
              email: this.localStorage.get("user")["email"],
            },
            replyingTo: this.replyingTo,
          },
          meta: null,
        };

        if (messageCopy !== "") {
          addDoc(
            collection(
              this.firestore,
              `chats/${this.conversation.uuid}/messages`,
            ),
            publishConfig.message,
          )
            .then(({ id }: any) => {
              this.dashboardService.show_loading.next(false);
              const response: any = this.aiAssistantService.updatePineconeMessage(
                {
                  ...publishConfig.message,
                  id,
                  client_company_id: this.company_id,
                  client_company: this.company_name,
                },
              );

              this.readConversation();
            })
            .catch((err) => {
              console.log("Error sending message", err);
            });
        }

        this.replyingTo = null;
      }
    }

    this.resetSearch();
  }

  openComments(tracked_item_id): void {
    for (let x = 0; x < this.conversation.messages.length; x++) {
      if (this.conversation.messages[x].tracked_item !== null) {
        if (this.conversation.messages[x].tracked_item.id == tracked_item_id) {
          this.conversation.messages[x].commentsOpen = true;

          if (this.data.user_type == 2) {
            this.clientService.switchTabSubject.next("tracked-items");
          }
        }
      }
    }
  }

  handleVisibilityChange() {
    this.is_tab_hidden = document.hidden;
  }

  readConversation() {
    if (this.conversation.id != null && this.conversation.id != 0) {
      this.conversationsService
        .read_conversation(this.conversation.id)
        .then((res: any) => {});
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      try {
        this.scrollMe.nativeElement.scrollTop =
          this.scrollMe.nativeElement.scrollHeight;
      } catch (err) {}
    }, 200);
  }

  jumpToMessage(message) {
    this.conversation.messages = this.history;

    setTimeout(() => {
      let rendered_bubbles = this.bubbles.toArray();

      for (let b = 0; b < rendered_bubbles.length; b++) {
        if (rendered_bubbles[b].nativeElement != null) {
          if (rendered_bubbles[b].nativeElement.id == `bubble-${message.id}`) {
            this.searchMode = true;
            this.searchResultsMode = false;
            this.jumpedToMessage = true;

            setTimeout(() => {
              rendered_bubbles[b].nativeElement.scrollIntoView();
            }, 100);
            break;
          }
        }
      }
    }, 100);
  }

  resetSearch() {
    this.searchMode = false;
    this.searchResultsMode = false;
    this.jumpedToMessage = false;
    this.searchText = "";
    jQuery(".highlighted-result").removeClass("highlighted-result");

    this.scrollToBottom();
  }

  doneSearching() {
    this.searchMode = false;
    this.searchResultsMode = false;
    this.jumpedToMessage = false;
    this.searchText = "";
    jQuery(".highlighted-result").removeClass("highlighted-result");
  }

  backToSearchResults() {
    this.searchResultsMode = true;
    this.jumpedToMessage = false;
  }

  // generateMessageId(message) {
  //   if (message.date !== undefined) {
  //     let m = new Date(message.date.seconds * 1000)
  //       .toDateString()
  //       .replace("-", "");
  //     m = m.replace("-", "");
  //     m = m.replace(":", "");
  //     m = m.replace(":", "");
  //     m = m.replace(".", "");
  //     m = m.replace(" ", "");
  //     // console.log(m);
  //     return m;
  //   }
  // }

  loadMoreMessages() {
    if (this.conversation.messages.length % 100 == 0) {
      this.chatService.changeConversationSubscription(
        this.chatService.getClientByConversationUUID(this.conversation.uuid),
        100 * (this.conversation.messages.length / 100 + 1),
      );
    }
  }

  cancelDropzone(event: Event) {
    event.stopPropagation();
    this.showDropzone = false;
    this.files = [];
    this.has_file = false;
    if (this.chatFile && this.chatFile.nativeElement) {
      this.chatFile.nativeElement.value = '';
    }
    this.dragCounter = 0;
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter++;
    if (!this.upload_loading && !this.showDropzone) {
      this.showDropzone = true;
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0 && !this.upload_loading && this.showDropzone) {
      this.showDropzone = false;
      this.files = [];
      this.has_file = false;
      if (this.chatFile && this.chatFile.nativeElement) {
        this.chatFile.nativeElement.value = '';
      }
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter = 0;
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const droppedFiles = Array.from(event.dataTransfer.files);
      this.handleFiles(droppedFiles);
      this.showDropzone = true; // Ensure dropzone is visible if not already
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    // Optionally, you can ensure the dropzone stays visible while dragging
    if (!this.upload_loading && !this.showDropzone) {
      this.showDropzone = true;
    }
  }
}
